import { render } from "./AdminClient.vue?vue&type=template&id=fd17fd1c"
import script from "./AdminClient.vue?vue&type=script&lang=js"
export * from "./AdminClient.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__